import { observable, action, runInAction } from 'mobx'
import Api from '@api/testApi'
import { getFuncVal, hasSomeKey, isObj } from '@hlj/hlj-utils'

export default class {
  $searchBar = null
  $params = {}
  $listApi = Api.getListApi
  @observable $filters = {}
  @observable $sorter = {}
  $pageSize = 10
  $initialParams = {}
  $pageKey = 'page'
  $pageSizeKey = 'per_page'
  //不需要在最后发请求时传递的参数名
  $ignoreParams = []
  $loadMore = false
  $getListApi = () => {
    return this.$listApi
  }
  @observable $list = []
  @observable $loading = false
  @observable
  $pagination = {
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: this.$pageSize,
    total: 0
  }

  @observable $selectedRowKeys = []
  @action
  $onSelectChange = keys => {
    this.$selectedRowKeys = keys
  }
  @action
  $paging = ({ current, pageSize }, filters, sorter) => {
    this.$filters = filters
    this.$sorter = sorter
    this.$pagination.current = current
    this.$pagination.pageSize = pageSize
    this.$getList(current)
  }
  /*
   切面，发请求之前和之后的操作$beforeGet,$afterGet
   */
  @action
  $afterGet = (data, page) => {
    const { list, total_count, totalCount } = data
    if (this.$loadMore) {
      if (page == 1) {
        this.$list = list || []
      } else {
        this.$list = this.$list.concat(list)
      }
    } else {
      this.$list = list || []
    }
    this.$pagination.total = +total_count || +totalCount || 0
    this.$pagination.current = page
    this.$selectedRowKeys = []
    this.$loading = false
    this.$extraOp && this.$extraOp(data, page)
  }

  @action
  $getList = async (page = this.$pagination.current, params) => {
    this.$loading = true
    /**
     *  $beforeGet = async () => {
     *    await this.getMenuList()
     *    return this.$beforeGet = null // 注意如果只想运行一次$beforeGet，记得重制
     *  }
     */
    this.$beforeGet && (await this.$beforeGet())
    if (isObj(page)) {
      params = page
      page = this.$pagination.current
    }
    const resParams = {
      [this.$pageKey]: page,
      [this.$pageSizeKey]: this.$pagination.pageSize,
      ...this.$initialParams,
      ...this.$getParams(this.$pagination),
      ...params
    }
    const ignoreParams = getFuncVal(this.$ignoreParams, resParams) || []
    for (let key of ignoreParams) {
      delete resParams[key]
    }

    const { data } = await this.$getListApi()(resParams)
    runInAction(() => {
      this.$afterGet(data, page)
    })
  }
  /**
   和编辑有关
   */
  //编辑之后的数据字段
  $editedInfo = {}
  /*
   保存编辑后的数据
   */
  $getEditor = () => {
    /*
       获取编辑之后的新数据data,
       做相应处理之后成功保存到数据库后
       千万要记得重置编辑器reset()
       */
    return {
      data: this.$editedInfo,
      reset: () => {
        this.$editedInfo = {}
      }
    }
  }
  /**
   * 参数的处理
   */
  $initParams = (name, value) => {
    this.$initialParams[name] = value
    this.$params = Object.assign({}, this.$initialParams, this.$params)
  }

  $clearParams = () => {
    this.$params = {}
  }
  $resetParams = () => {
    this.$params = Object.assign({}, this.$initialParams)
  }
  $search = () => {
    this.$getList(1)
  }

  $getParams() {
    return this.$params
  }

  //当参数改变的时候调用
  $onParamsChange = () => {
    this.$getList(1)
  }

  $setParams = (values, noNeed = []) => {
    if (values) {
      this.$params = Object.assign({}, this.$params, values)
    } else {
      this.$resetParams()
    }
    if (noNeed && !hasSomeKey(values, noNeed)) {
      this.$onParamsChange(values)
    }
  }
}
